import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getReferencesFilter, getThread } from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { summaryService } from "../api";
import HorisontalChart from "./HorizontalChart";
import { findSource } from "../scripts/utils";
import { feedFilterClear } from "../redux/actions";
import { useAppDispatch } from "../redux/store/hooks";

const PostsHorizontal: React.FC = () => {
  const thread = useSelector(getThread);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [dataArr, setDataArr] = useState([]);
  const [labelsArr, setLabelsArr] = useState([]);
  const referencesFilter = useSelector(getReferencesFilter);
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(feedFilterClear());
  }, []);

  useEffect(() => {
    if (thread) {
      let params = {
        thread_id: +thread.id,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        referenceFilter: referencesFilter,
      };
      setLoading(true);
      summaryService
        .loadTrustDailyPosts(params)
        .then((resp) => {
          let arr: any = [];
          for (let key in resp) {
            let data: any = {};
            let result = resp[key].total.reduce(function (
              sum: any,
              current: any
            ) {
              return sum + current[1];
            },
            0);
            if (
              key == "tg" ||
              key == "vk" ||
              key == "ok" ||
              key == "yt" ||
              key == "dz"
            ) {
              data["count"] = result;
              data["key"] = key;
              arr.push(data);
            } else if (key == "total") setTotal(result);
          }
          arr.sort((a: any, b: any) => b.count - a.count);
          setDataArr(arr.map((it: any) => it.count));
          setLabelsArr(arr.map((it: any) => it.key));
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, feedFilter, referencesFilter]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="white-block-small">
      <div className="">
        <p className="block-title">
          По количеству публикаций в Соцсетях
          <InfoCircleOutlined className="info" onClick={showDrawer} />
        </p>
      </div>
      {loading ? (
        <div className="feed-posts-loader" style={{ height: "300px" }}>
          <LoadingOutlined />
        </div>
      ) : (
        <HorisontalChart labelsArr={labelsArr} dataArr={dataArr} />
      )}
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          График иллюстрирует суммарное количество публикаций с упоминаниями
          компании в каждой социальной сети за выбранный период.
        </p>
        <p className="title-small">Источники данных</p>
        <ul>
          <li>Telegram</li>
          <li>Вконтакте</li>
          <li>Одноклассники</li>
          <li>Youtube</li>
          <li>Дзен</li>
        </ul>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default PostsHorizontal;
